<script lang="ts" setup>
import { cva, type VariantProps } from 'class-variance-authority'

import { classMerge } from '../utils'

const badgeVariants = cva('flex justify-center items-center font-heading', {
  variants: {
    type: {
      numeric: 'rotate-45',
      icon: 'rotate-45',
      text: 'h-auto w-fit'
    },
    variant: {
      primary: 'bg-accent text-accent-foreground',
      secondary: 'bg-accent-secondary text-accent-secondary-foreground',
      tertiary: 'bg-accent-tertiary text-accent-tertiary-foreground',
      quarternary: 'bg-accent-quarternary text-accent-quarternary-foreground',
      ghost: 'bg-accent-ghost text-accent-ghost-foreground'
    },
    size: {
      xl: '',
      lg: '',
      md: '',
      sm: '',
      xs: ''
    },
    uppercase: {
      true: 'uppercase'
    }
  },
  compoundVariants: [
    {
      type: 'numeric',
      size: 'xl',
      class: 'h-badge-xl w-badge-xl'
    },
    {
      type: 'numeric',
      size: 'lg',
      class: 'h-badge-lg w-badge-lg'
    },
    {
      type: 'numeric',
      size: 'md',
      class: 'h-badge-md w-badge-md'
    },
    {
      type: 'numeric',
      size: 'sm',
      class: 'h-badge-sm w-badge-sm'
    },
    {
      type: 'numeric',
      size: 'xs',
      class: 'h-badge-xs w-badge-xs'
    },
    {
      type: 'icon',
      size: 'xl',
      class: 'h-badge-xl w-badge-xl'
    },
    {
      type: 'icon',
      size: 'lg',
      class: 'h-badge-lg w-badge-lg'
    },
    {
      type: 'icon',
      size: 'md',
      class: 'h-badge-md w-badge-md'
    },
    {
      type: 'icon',
      size: 'sm',
      class: 'h-badge-sm w-badge-sm'
    },
    {
      type: 'icon',
      size: 'xs',
      class: 'h-badge-xs w-badge-xs'
    }
  ],
  defaultVariants: {
    variant: 'primary',
    size: 'lg',
    uppercase: true
  }
})

type BadgeProps = VariantProps<typeof badgeVariants>

withDefaults(
  defineProps<{
    type?: BadgeProps['type'],
    variant?: BadgeProps['variant'],
    size?: BadgeProps['size'],
    uppercase?: BadgeProps['uppercase'],

  }>(),
  {
    type: 'text',
    variant: 'primary',
    size: 'lg',
    uppercase: true
  }
)
</script>

<template>
  <div :class="classMerge(badgeVariants({ type, variant, size, uppercase }), $attrs.class ?? '')">
    <slot />
  </div>
</template>
